import React, { useContext } from 'react';

import cx from 'classnames';

import LandingPageContext from '../../contexts/LandingPageContext';
import SmMenu from '../AddNewContent/SmMenu';
import styles from './index.module.css';
import { IContentWrapperProps } from './types';

function ContentWrapper({
  children,
  indexes,
  onDelete,
  hasImageButton,
  hasDocumentButton,
  data,
  onUpdate,
}: IContentWrapperProps) {
  const { readOnly } = useContext(LandingPageContext);

  return (
    <div className={cx(styles.wrapper, 'custom-right-content-wrapper')}>
      {!readOnly && (
        <SmMenu
          className={styles.smMenuVisible}
          indexes={indexes}
          onDelete={onDelete}
          onUpdate={onUpdate}
          hasImageButton={hasImageButton}
          hasDocumentButton={hasDocumentButton}
          data={data}
        />
      )}
      {children}
    </div>
  );
}

export default ContentWrapper;
